/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge25 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])

	const fill: any = props.item.fill || "var(--force-contast-color)" 

	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<g>
				<path fill={"#FFCC4D"} d="M188.7,33.9c-0.4,0.1-0.9-0.1-1.2-0.2c-0.5-0.2-1.1-0.4-1.6-0.6c0,0.2,0,0.5,0,0.7c0,0.5-0.1,1-0.1,1.5
					c-0.1,0.5-0.1,1-0.5,1.4c-0.4,0.4-1,0.2-1.3-0.2c-0.5-0.7-0.7-1.5-0.9-2.3c-0.1-0.5-0.3-1.1-0.3-1.7c-0.7,0.3-1.4,0.6-2.2,0.9
					c-0.4,0.2-0.9,0.3-1.3,0.1c-0.3-0.2-0.5-0.5-0.5-0.9c0-0.8,0.7-1.6,1.2-2.1c0.3-0.3,0.7-0.6,1-0.9c-0.2-0.3-0.4-0.7-0.6-1
					c-0.4-0.7-0.8-1.5-0.9-2.3c0-0.6,0.6-0.8,1-0.6c0.6,0.3,1.1,0.7,1.5,1.2c0.4,0.4,0.8,0.9,1.1,1.3c0.3-0.6,0.6-1.1,0.9-1.6
					c0.3-0.5,0.9-1.5,1.7-1.4c1,0.1,0.6,1.4,0.5,2c-0.2,0.8-0.4,1.5-0.5,2.3c0,0,0,0,0,0c0.3,0.3,0.7,0.5,1,0.7c0.4,0.2,0.7,0.5,1,0.7
					c0.3,0.2,0.6,0.5,0.9,0.8c0.3,0.3,0.6,0.6,0.7,1C189.4,33.3,189.1,33.8,188.7,33.9z"/>
				<path fill={"#FFCC4D"} d="M196.5,6.7c-0.6-0.3-1.3-0.2-1.9-0.2c-0.8,0.1-1.7,0.1-2.6,0.3c0.1-0.3,0.1-0.7,0.2-1
					c0.1-0.7,0.2-1.5,0.3-2.2c0.1-0.7,0.2-1.5-0.2-2.1c-0.4-0.8-1.3-0.7-1.9-0.2c-0.9,0.8-1.6,1.8-2.2,2.9c-0.4,0.7-0.8,1.5-1.1,2.3
					c-0.9-0.7-1.8-1.4-2.8-2.1c-0.5-0.4-1.1-0.7-1.8-0.6c-0.6,0.1-1,0.6-1.1,1.1c-0.4,1.2,0.4,2.5,1,3.5c0.3,0.6,0.7,1.1,1.1,1.7
					c-0.5,0.3-0.9,0.8-1.2,1.1c-0.8,0.8-1.7,1.8-2.1,2.9c-0.3,0.8,0.5,1.4,1.3,1.3c0.9-0.2,1.8-0.7,2.6-1.2c0.7-0.5,1.4-1,2.1-1.5
					c0.2,0.9,0.4,1.8,0.7,2.7c0.3,0.9,0.7,2.5,1.9,2.7c1.4,0.1,1.4-1.8,1.4-2.8c0-1.2,0-2.3,0.1-3.5c0,0,0.1,0,0.1,0
					c0.5-0.3,1.2-0.5,1.7-0.7c0.6-0.2,1.2-0.4,1.8-0.7c0.5-0.2,1.1-0.5,1.6-0.8c0.5-0.3,1.1-0.7,1.4-1.2C197.2,7.8,197,7,196.5,6.7z"
					/>
				<g>
					<path fill={fill} d="M235.1,31.8c-0.2,0.2-0.5,0.3-0.8,0.3c-0.3,0-0.6-0.1-0.8-0.4c-5.7-6.2-11.9-10.6-18.4-13.2
						c-7.1-2.8-14.8-4-22.1-3.5c-0.7,0-1.2-0.2-1.6-0.7c-0.4-0.6-0.4-1.4-0.1-2c0.3-0.6,0.9-1,1.6-1c8.1-0.5,16.2,1,23.6,4.4
						c8,3.7,14.3,8.6,18.8,14.5C235.6,30.8,235.6,31.4,235.1,31.8z"/>
					<path fill={fill} d="M182.9,20.8c0.4-0.8,1.1-1.2,1.9-1.3c21.2-1.4,39.4,4.1,51.2,15.4c0.6,0.5,0.6,1.3,0.1,1.9
						c-0.3,0.3-0.7,0.5-1.2,0.5c-0.3,0-0.6-0.1-0.9-0.3c-16.2-12.7-35.7-14-49.1-12.9c-0.8,0.1-1.5-0.2-1.9-0.9
						C182.5,22.5,182.5,21.6,182.9,20.8z"/>
					<path fill={fill} d="M191,27.6L191,27.6c13.7-1.3,27.8,1.4,39.8,7.5c0.7,0.4,1,1.2,0.6,1.9c-0.2,0.6-0.8,0.9-1.3,0.9
						c-0.2,0-0.3,0-0.5-0.1c-6.5-2.3-12.8-3.9-19-4.9c-5.9-1-12.3-1.3-19.6-1.1c-1.2,0-2-0.7-2.1-1.9C188.9,28.9,189.6,27.7,191,27.6z
						"/>
				</g>
				<path fill={"#FFCC4D"} d="M172.7,17.2c0.4,0,0.7,0.2,1.1,0.4c0.4,0.2,0.8,0.4,1.2,0.6c0-0.3,0.1-0.6,0.1-0.9c0.1-0.4,0.2-0.8,0.3-1.2
					c0.1-0.4,0.3-0.8,0.5-1.1c0.3-0.3,0.8-0.3,1.1,0.1c0.2,0.3,0.4,0.8,0.5,1.1c0.2,0.6,0.2,1.2,0.3,1.8c0.4-0.3,0.9-0.5,1.3-0.7
					c0.5-0.2,1.4-0.7,1.9-0.3c0.6,0.5,0,1.4-0.4,1.8c-0.4,0.6-1,1-1.5,1.6c-0.1,0.1-0.1,0.1-0.2,0.2c0.2,0.9,0.3,1.8,0.4,2.7
					c0.1,0.5,0.1,1.1-0.4,1.4c-0.8,0.5-1.5-0.6-1.8-1.1c-0.4-0.5-0.7-1.1-1.1-1.6c-0.4,0.3-0.7,0.6-1.1,1c-0.5,0.4-1.1,1.1-1.8,0.6
					c-0.6-0.4-0.1-1.4,0.1-1.9c0.2-0.5,0.5-1,0.7-1.4c-0.3-0.2-0.6-0.4-0.9-0.7c-0.3-0.2-0.5-0.5-0.7-0.8c-0.2-0.3-0.5-0.5-0.5-0.9
					C172,17.4,172.3,17.2,172.7,17.2z"/>
			</g>
			<path fill={"#FFCC4D"} d="M261.6,28.9c-0.2-0.3-0.7-0.4-1-0.3c-2.6,1.1-5.1,2.3-7.5,3.8c0-0.2,0-0.3-0.1-0.5c-0.1-1.1-0.2-2.2-0.4-3.3
				c-0.2-2-0.3-4.1-1-5.9c-0.3-0.7-0.7-1.7-1.6-1.5c-0.8,0.1-1.2,1.3-1.5,2c-0.7,1.9-0.9,4-1.2,6c-0.1,1-0.3,1.9-0.4,2.9
				c-1.4-0.5-2.8-0.9-4.3-1.4c-0.4-0.1-0.8-0.3-1.2-0.4c-0.7-0.2-1.4-0.4-2.1-0.7c-0.6-0.4-1.3-0.8-1.9-0.8c-1-0.1-1.9,0.7-1.6,1.7
				c0.1,0.4,0.5,0.7,0.8,1c0.3,0.3,0.6,0.7,0.9,1c0.6,0.6,1.2,1.2,1.9,1.8c1.4,1.2,2.9,2.4,4.5,3.3c-1.3,1.3-2.3,2.8-3.2,4.3
				c-0.5,0.9-1.1,1.8-1.5,2.8c-0.4,1-0.2,2.3,1,2.6c1.1,0.3,2-0.7,2.8-1.3c0.8-0.7,1.5-1.4,2.3-2.1c1.3-1.3,2.5-2.7,3.6-4.2
				c0.2,0.4,0.3,0.8,0.5,1.3c0.3,0.9,0.7,1.7,1.2,2.5c1,1.7,2.2,3.2,3.9,4.2c0.4,0.3,1,0.5,1.5,0.4c0.5-0.1,0.8-0.5,0.9-1
				c0.3-1.2-0.3-2.5-0.7-3.6c-0.5-1.6-1-3.2-1.5-4.7c0.2-0.1,0.4-0.3,0.6-0.5c0.4-0.3,0.9-0.6,1.3-1c0.9-0.7,1.9-1.4,2.7-2.2
				C260.8,33.5,263.4,30.9,261.6,28.9z M248.2,37.3C248.2,37.3,248.2,37.3,248.2,37.3C248.2,37.4,248.2,37.4,248.2,37.3
				C248.2,37.3,248.2,37.3,248.2,37.3z M250.2,22.8C250.2,22.8,250.1,22.8,250.2,22.8C250.1,22.8,250.1,22.8,250.2,22.8
				C250.2,22.8,250.2,22.8,250.2,22.8z M241.7,44.2C241.7,44.2,241.7,44.2,241.7,44.2C241.7,44.3,241.7,44.3,241.7,44.2
				C241.7,44.3,241.7,44.3,241.7,44.2z"/>
			<path fill={fill} d="M244.3,25c-0.1-1.5-0.9-2.8-1.7-4.1c-0.8-1.2-1.6-2.8-3-3.2c-0.8-0.2-1.4,0.4-1.5,1.2
				c-0.2,1.4,1.1,2.8,1.9,3.9c0.8,1.1,1.7,2.4,3,3C243.5,26,244.3,25.7,244.3,25L244.3,25z"/>
			<path fill={fill} d="M256.6,26.4c0.9-0.2,1.5-0.9,2.1-1.6c0.7-0.7,1.3-1.4,2-2.2c1-1.2,2.9-3,2.4-4.7c-0.1-0.4-0.6-0.8-1.1-0.8
				c-1.8,0.1-2.9,2.3-3.8,3.6c-0.5,0.7-1.1,1.5-1.7,2.2c-0.6,0.8-1.2,1.3-1.3,2.4C255.1,26.1,256,26.5,256.6,26.4L256.6,26.4z"/>
			<path fill={fill} d="M250.3,17.7c1.1-0.8,1-2.1,1.1-3.4c0.1-1.3,0.4-2.7-0.6-3.7c-0.4-0.4-1.1-0.4-1.5,0c-0.9,1-0.7,2.3-0.7,3.5
				c0,1.2-0.3,2.5,0.5,3.4C249.4,17.9,250,18,250.3,17.7L250.3,17.7z"/>
			<g>
				<path fill={"#FFCC4D"} d="M311.3,33.9c0.4,0.1,0.9-0.1,1.2-0.2c0.5-0.2,1.1-0.4,1.6-0.6c0,0.2,0,0.5,0,0.7c0,0.5,0.1,1,0.1,1.5
					c0.1,0.5,0.1,1,0.5,1.4c0.4,0.4,1,0.2,1.3-0.2c0.5-0.7,0.7-1.5,0.9-2.3c0.1-0.5,0.3-1.1,0.3-1.7c0.7,0.3,1.4,0.6,2.2,0.9
					c0.4,0.2,0.9,0.3,1.3,0.1c0.3-0.2,0.5-0.5,0.5-0.9c0-0.8-0.7-1.6-1.2-2.1c-0.3-0.3-0.7-0.6-1-0.9c0.2-0.3,0.4-0.7,0.6-1
					c0.4-0.7,0.8-1.5,0.9-2.3c0-0.6-0.6-0.8-1-0.6c-0.6,0.3-1.1,0.7-1.5,1.2c-0.4,0.4-0.8,0.9-1.1,1.3c-0.3-0.6-0.6-1.1-0.9-1.6
					c-0.3-0.5-0.9-1.5-1.7-1.4c-1,0.1-0.6,1.4-0.5,2c0.2,0.8,0.4,1.5,0.5,2.3c0,0,0,0,0,0c-0.3,0.3-0.7,0.5-1,0.7
					c-0.4,0.2-0.7,0.5-1,0.7c-0.3,0.2-0.6,0.5-0.9,0.8c-0.3,0.3-0.6,0.6-0.7,1C310.6,33.3,310.9,33.8,311.3,33.9z"/>
				<path fill={"#FFCC4D"} d="M303.5,6.7c0.6-0.3,1.3-0.2,1.9-0.2c0.8,0.1,1.7,0.1,2.6,0.3c-0.1-0.3-0.1-0.7-0.2-1
					c-0.1-0.7-0.2-1.5-0.3-2.2c-0.1-0.7-0.2-1.5,0.2-2.1c0.4-0.8,1.3-0.7,1.9-0.2c0.9,0.8,1.6,1.8,2.2,2.9c0.4,0.7,0.8,1.5,1.1,2.3
					c0.9-0.7,1.8-1.4,2.8-2.1c0.5-0.4,1.1-0.7,1.8-0.6c0.6,0.1,1,0.6,1.1,1.1c0.4,1.2-0.4,2.5-1,3.5c-0.3,0.6-0.7,1.1-1.1,1.7
					c0.5,0.3,0.9,0.8,1.2,1.1c0.8,0.8,1.7,1.8,2.1,2.9c0.3,0.8-0.5,1.4-1.3,1.3c-0.9-0.2-1.8-0.7-2.6-1.2c-0.7-0.5-1.4-1-2.1-1.5
					c-0.2,0.9-0.4,1.8-0.7,2.7c-0.3,0.9-0.7,2.5-1.9,2.7c-1.4,0.1-1.4-1.8-1.4-2.8c0-1.2,0-2.3-0.1-3.5c0,0-0.1,0-0.1,0
					c-0.5-0.3-1.2-0.5-1.7-0.7c-0.6-0.2-1.2-0.4-1.8-0.7c-0.5-0.2-1.1-0.5-1.6-0.8c-0.5-0.3-1.1-0.7-1.4-1.2
					C302.8,7.8,303,7,303.5,6.7z"/>
				<g>
					<path fill={fill} d="M264.9,31.8c0.2,0.2,0.5,0.3,0.8,0.3c0.3,0,0.6-0.1,0.8-0.4c5.7-6.2,11.9-10.6,18.4-13.2
						c7.1-2.8,14.8-4,22.1-3.5c0.7,0,1.2-0.2,1.6-0.7c0.4-0.6,0.4-1.4,0.1-2c-0.3-0.6-0.9-1-1.6-1c-8.1-0.5-16.2,1-23.6,4.4
						c-8,3.7-14.3,8.6-18.8,14.5C264.4,30.8,264.4,31.4,264.9,31.8z"/>
					<path fill={fill} d="M317.1,20.8c-0.4-0.8-1.1-1.2-1.9-1.3c-21.2-1.4-39.4,4.1-51.2,15.4c-0.6,0.5-0.6,1.3-0.1,1.9
						c0.3,0.3,0.7,0.5,1.2,0.5c0.3,0,0.6-0.1,0.9-0.3c16.2-12.7,35.7-14,49.1-12.9c0.8,0.1,1.5-0.2,1.9-0.9
						C317.5,22.5,317.5,21.6,317.1,20.8z"/>
					<path fill={fill} d="M309,27.6L309,27.6c-13.7-1.3-27.8,1.4-39.8,7.5c-0.7,0.4-1,1.2-0.6,1.9c0.2,0.6,0.8,0.9,1.3,0.9
						c0.2,0,0.3,0,0.5-0.1c6.5-2.3,12.8-3.9,19-4.9c5.9-1,12.3-1.3,19.6-1.1c1.2,0,2-0.7,2.1-1.9C311.1,28.9,310.4,27.7,309,27.6z"/>
				</g>
				<path fill={"#FFCC4D"} d="M327.3,17.2c-0.4,0-0.7,0.2-1.1,0.4c-0.4,0.2-0.8,0.4-1.2,0.6c0-0.3-0.1-0.6-0.1-0.9
					c-0.1-0.4-0.2-0.8-0.3-1.2c-0.1-0.4-0.3-0.8-0.5-1.1c-0.3-0.3-0.8-0.3-1.1,0.1c-0.2,0.3-0.4,0.8-0.5,1.1c-0.2,0.6-0.2,1.2-0.3,1.8
					c-0.4-0.3-0.9-0.5-1.3-0.7c-0.5-0.2-1.4-0.7-1.9-0.3c-0.6,0.5,0,1.4,0.4,1.8c0.4,0.6,1,1,1.5,1.6c0.1,0.1,0.1,0.1,0.2,0.2
					c-0.2,0.9-0.3,1.8-0.4,2.7c-0.1,0.5-0.1,1.1,0.4,1.4c0.8,0.5,1.5-0.6,1.8-1.1c0.4-0.5,0.7-1.1,1.1-1.6c0.4,0.3,0.7,0.6,1.1,1
					c0.5,0.4,1.1,1.1,1.8,0.6c0.6-0.4,0.1-1.4-0.1-1.9c-0.2-0.5-0.5-1-0.7-1.4c0.3-0.2,0.6-0.4,0.9-0.7c0.3-0.2,0.5-0.5,0.7-0.8
					c0.2-0.3,0.5-0.5,0.5-0.9C328,17.4,327.7,17.2,327.3,17.2z"/>
			</g>
		</svg>
	</div>
}

